export interface ConversationMessage {
    content: string;
    isUser: boolean;
    timestamp: Date;
}

export interface SupportChatRequest {
    message: string;
    conversationHistory?: ConversationMessage[];
}

export interface SupportChatResponse {
    response: string;
    timestamp: Date;
}

const API_BASE_URL = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

class SupportChatApiService {
    private getAuthHeaders() {
        const token = localStorage.getItem('authToken');
        return {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        };
    }

    async sendMessage(request: SupportChatRequest): Promise<SupportChatResponse> {
        const response = await fetch(`${API_BASE_URL}/SupportChat/SendMessage`, {
            method: 'POST',
            headers: this.getAuthHeaders(),
            body: JSON.stringify(request),
        });

        if (!response.ok) {
            throw new Error('Failed to send support chat message');
        }

        return await response.json();
    }
}

export const supportChatApi = new SupportChatApiService();
